/**
 * Sets active language for Response Editor
 */
export function setActiveLanguage(responseId: string, language: string): {
  type: "SET_ACTIVE_LANGUAGE",
  responseId: string,
  language: string
} {
  return {
    type: "SET_ACTIVE_LANGUAGE",
    responseId,
    language
  };
}
